export type ThemePreference = 'system' | 'dark' | 'light'
export type ResolvedTheme = Exclude<ThemePreference, 'system'>

export const themePreferences: readonly ThemePreference[] = ['system', 'dark', 'light']
export const THEME_STORAGE_KEY = 'reca-theme-preference'

export function isThemePreference(value: unknown): value is ThemePreference {
  return typeof value === 'string' && themePreferences.includes(value as ThemePreference)
}

export function resolveTheme(preference: ThemePreference, systemPrefersDark: boolean): ResolvedTheme {
  return preference === 'system' ? (systemPrefersDark ? 'dark' : 'light') : preference
}
